<ion-list lines="none">
  <ion-item>
    <ion-icon src="/assets/icons/24px/speakers-off.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Why Headphones Matter</h3>
      </ion-text>

      <ion-text color="black">
        <p>Headphones are preferred over Speakers because they prevent Echo and Volume Ducking</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/bluetooth-off.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Bluetooth Not Recommended</h3>
      </ion-text>

      <ion-text color="black">
        <p>Bluetooth headphones can add latency, degrade quality, and are not recommended</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item *ngIf="osHeadphonesSelection">
    <ion-icon src="/assets/icons/24px/headphones.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>OS Headphones Selection</h3>
      </ion-text>

      <ion-text color="black">
        <p>
          {{ osHeadphonesSelection }}
        </p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
